/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import {CRISPRAnalysisSequenceAttributes} from 'constants/CRISPRConstants';
// @ts-expect-error
import CRISPRAnalysisActions from 'molbio/crispr/CRISPRAnalysisActions';
import * as CRISPRUtil from 'molbio/crispr/CRISPRUtil';
import * as sequtil from 'molbio/SeqUtil';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface RegenerateAnalysisPreviewProps {
  regions: Array<any>;
  regeneratingAnalysis: boolean;
  sequence: CRISPRAnalysisSequenceAttributes;
}

class RegenerateAnalysisPreview extends React.Component<RegenerateAnalysisPreviewProps> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  displayRegion = (region: any) => `(${sequtil.modelStartToDisplay(
    region.start,
    this.props.sequence.startIndex
  )}, \
${
  region.end === 0
    ? 'end'
    : sequtil.modelEndToDisplay(region.end, this.props.sequence.length, this.props.sequence.startIndex)
})`;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  formatRegions = (regions: any, verb: any, className: any) => {
    if (regions.length === 0) {
      return null;
    }

    const displays = Array.from(regions)
      .map((region) => this.displayRegion(region))
      .join(', ');
    return (
      <p className={className} key={verb}>
        {`${benchlingUtil.pluralize(regions.length, 'Target region')} ${displays} will be ${verb}.`}
      </p>
    );
  };

  shouldComponentUpdate(nextProps: RegenerateAnalysisPreviewProps, nextState: any): boolean {
    return !nextProps.regeneratingAnalysis;
  }

  render(): JSX.Element {
    const willBeDeleted = [];
    const willBeKept = [];
    for (const region of Array.from(this.props.regions)) {
      if (CRISPRUtil.canRegenerateRegion(region, this.props.sequence.length)) {
        willBeKept.push(region);
      } else {
        willBeDeleted.push(region);
      }
    }

    return (
      <div>
        {this.props.regions.length === 0 ? (
          <p className="u-primary-color">No target regions found in analysis. No changes will be made.</p>
        ) : (
          [
            this.formatRegions(willBeDeleted, 'deleted', 'u-danger-color'),
            this.formatRegions(willBeKept, 'kept', 'u-success-color'),
          ]
        )}
      </div>
    );
  }
}

interface CRISPRAnalysisTabBlockedProps {
  allowEdits: boolean;
  analysis: {
    id: string;
    regions: Array<any>;
    originalBases?: string;
  };
  findGuidesParams: any;
  openSequenceVersion: (...args: Array<any>) => any;
  originalSequenceVersion?: any;
  regeneratingAnalysis: boolean;
  sequence: CRISPRAnalysisSequenceAttributes;
  versionIds: Array<number>;
}

type CRISPRAnalysisTabBlockedState = any;

class CRISPRAnalysisTabBlocked extends React.Component<
  CRISPRAnalysisTabBlockedProps,
  CRISPRAnalysisTabBlockedState
> {
  state: CRISPRAnalysisTabBlockedState = {
    showRegenerateAnalysisPreview: false,
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  regenerateAnalysis = () => {
    CRISPRAnalysisActions.regenerateAnalysis(
      this.props.analysis,
      this.props.sequence,
      this.props.findGuidesParams
    );
  };

  componentDidMount(): void {
    CRISPRAnalysisActions.fetchOriginalSequenceVersion(this.props.analysis.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps: CRISPRAnalysisTabBlockedProps): void {
    if (
      this.props.originalSequenceVersion != null &&
      !Array.from(nextProps.versionIds).includes(this.props.originalSequenceVersion.id)
    ) {
      CRISPRAnalysisActions.fetchOriginalSequenceVersion(this.props.analysis.id);
    }
  }

  render(): JSX.Element {
    return (
      <div className="alert alert-warning">
        <p>The sequence associated with this analysis has changed.</p>
        {this.props.originalSequenceVersion != null ? (
          <p>
            {'Please revert sequence to '}
            <a
              className="alert-link"
              onClick={() => this.props.openSequenceVersion(this.props.originalSequenceVersion.id)}
            >
              {this.props.originalSequenceVersion.name}
            </a>
            {' to view this analysis, or regenerate analysis with current sequence.'}
          </p>
        ) : (
          <p>Regenerate analysis with current sequence to continue.</p>
        )}
        {this.state.showRegenerateAnalysisPreview ? (
          <div className="u-tiny-spacing-top">
            <RegenerateAnalysisPreview
              regions={this.props.analysis.regions}
              regeneratingAnalysis={this.props.regeneratingAnalysis}
              sequence={this.props.sequence}
            />
          </div>
        ) : undefined}
        <p>
          {this.state.showRegenerateAnalysisPreview ? (
            <Button
              buttonStyle={ButtonStyle.PRIMARY}
              size={ButtonSize.SMALL}
              onClick={this.regenerateAnalysis}
              disabled={this.props.regeneratingAnalysis || !this.props.allowEdits}
              text={this.props.regeneratingAnalysis ? 'Regenerating analysis...' : 'Continue'}
            />
          ) : (
            <Button
              buttonStyle={ButtonStyle.PRIMARY}
              size={ButtonSize.SMALL}
              onClick={() => {
                this.setState({showRegenerateAnalysisPreview: true});
              }}
              disabled={!this.props.allowEdits}
              text="Regenerate Analysis"
            />
          )}
        </p>
      </div>
    );
  }
}

export default CRISPRAnalysisTabBlocked;
